import React from 'react';
import { Award } from 'lucide-react';

const PartnershipsSection = () => {
  return (
    <div className="py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900">Official Partnerships</h2>
          <p className="mt-4 text-xl text-gray-600">
            Certified training and implementation partner
          </p>
        </div>

        <div className="flex justify-center items-center">
          <div className="bg-white rounded-2xl shadow-xl p-8 hover:shadow-2xl transition-shadow">
            <div className="flex items-center space-x-4 mb-6">
              <Award className="h-8 w-8 text-blue-600" />
              <h3 className="text-xl font-semibold text-gray-900">Zimbra Training Partner</h3>
            </div>
            <div className="relative w-full h-32 bg-gradient-to-r from-[#FF3D00] to-[#FF8A00] rounded-lg p-6 flex items-center justify-center">
              <div className="text-white text-4xl font-bold tracking-wider">
                ZIMBRA
              </div>
              <div className="absolute bottom-2 right-2 text-white/80 text-sm">
                Training Partner
              </div>
            </div>
            <div className="mt-6 text-gray-600 text-center">
              Authorized provider of official Zimbra training and certification programs
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PartnershipsSection;